<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card dense>
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Mail Einstellungen</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-container>
                <h3>Absender</h3>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Absendername"
                      name="mailnamefrom"
                      type="text"
                      v-model="mailSettings.mailnamefrom"
                      :rules="requiredRule"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Absenderemail"
                      name="mailadressfrom"
                      type="text"
                      v-model="mailSettings.mailadressfrom"
                      :rules="emailRules"
                    />
                  </v-col>
                </v-row>
                <h3>SMTP Server Einstellungen</h3>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-checkbox
                      label="Externen Mailserver verwenden"
                      v-model="mailSettings.useexternalsmtp"
                      color="green"
                    />
                  </v-col>
                </v-row>
                <v-row v-show="mailSettings.useexternalsmtp">
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="SMTP Mailserver"
                      name="smtpserver"
                      type="text"
                      v-model="mailSettings.smtpserver"
                    />
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-text-field
                      label="SMTP Port"
                      name="smtpport"
                      type="number"
                      v-model="mailSettings.smtpport"
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-checkbox
                      label="TLS aktivieren"
                      v-model="mailSettings.smtptls"
                      color="green"
                    />
                  </v-col>
                </v-row>
                <v-row v-show="mailSettings.useexternalsmtp">
                  <v-col cols="12" sm="4">
                    <v-checkbox
                      label="SMTP Authentifizierung"
                      v-model="mailSettings.smtpauth"
                      color="green"
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-show="mailSettings.smtpauth"
                      label="SMTP User"
                      name="smtpuser"
                      type="text"
                      v-model="mailSettings.smtpuser"
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-show="mailSettings.smtpauth"
                      label="SMTP Passwort"
                      name="smtppass"
                      type="password"
                      v-model="mailSettings.smtppass"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="6">
                    <MailTemplateSelectbox
                      v-model="mailSettings.mailActivationTemplate"
                    />
                  </v-col>
                  <v-col sm="6">
                    <MailTemplateSelectbox
                      v-model="mailSettings.mailPwResetTemplate"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="save"
              color="success"
              name="submit"
              type="submit"
              :disabled="!formValid"
              >Speichern</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataService from "@/services/DataService";
import MailTemplateSelectbox from "@/components/settings/MailTemplateSelectbox";

export default {
  name: "MailSettings",
  components: { MailTemplateSelectbox },
  data: () => ({
    _id: null,
    mailSettings: {
      mailnamefrom: "",
      mailadressfrom: "",
      useexternalsmtp: true,
      smtpserver: "",
      smtpport: 587,
      smtptls: true,
      smtpauth: true,
      smtpuser: "",
      smtppass: "",
      mailActivationTemplate: "",
      mailPwResetTemplate: ""
    },
    requiredRule: [value => !!value || "Dieses Feld wird benötigt!"],
    emailRules: [
      v => !!v || "E-mail wird benötigt!",
      v =>
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail muss ein gültiges Format haben"
    ],
    formValid: true
  }),
  methods: {
    save() {
      console.log("save");
      DataService.apiClient
        .patch("/settings/mail", {
          _id: this._id,
          mailSettings: this.mailSettings
        })
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Einstellungen gespeichert",
            text: "Mail Einstellungen erfolgreich gespeichert"
          });
        })
        .catch(error => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message
          });
        });
    }
  },
  created() {
    DataService.apiClient
      .get("/settings/mail")
      .then(result => {
        if (result.data) {
          this._id = result.data.data._id;
          this.mailSettings = result.data.data.mailsettings;
        }
      })
      .catch(error => {
        this.$notify({
          group: "dataline",
          type: "error",
          title: "Fehler",
          text: error.message
        });
      });
  }
};
</script>
